var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade modal-with-custom-content position-fixed",
      class: {
        "modal-with-custom-content--dark-background":
          _vm.blockClickOutside || _vm.darkBackground,
        "modal-with-custom-content--wider": _vm.makeWider
      },
      style: "z-index:" + (_vm.zIndex || 999995),
      attrs: {
        id: _vm.modalId,
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": _vm.modalId,
        "aria-hidden": "true",
        "data-keyboard": _vm.blockClickOutside ? "false" : false,
        "data-backdrop": _vm.blockClickOutside ? "static" : false
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              !_vm.hideTopCloseButton
                ? _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "modal-body d-flex flex-column justify-content-center"
              },
              [
                _c(
                  "div",
                  { staticClass: "modal-custom-wrapper" },
                  [_vm._t("default")],
                  2
                ),
                _vm._v(" "),
                !_vm.hideBottomCloseButton
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary mt-3",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.closeModal($event)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.translate.home.close) +
                            "\n                "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a7db3b6", { render: render, staticRenderFns: staticRenderFns })
  }
}